import { logAmplitudeEvent } from 'amplitude/amplitude'
import React from 'react'
import { CreateButton, useTranslate } from 'react-admin'
import { UtilityTariffCatalogHeader } from './UtilityTariffCatalogHeader'
import { UtilityTariffCatalogSearchField } from './UtilityTariffCatalogSearchField'
import {
  CatalogActionsRow,
  CatalogFilterFields,
  CatalogPageStack,
  CatalogToolbarRow,
} from './utilityTariffCatalogStyles'

type UtilityTariffCatalogPageChromeProps = {
  heading?: string | React.ReactElement | false
  catalogFilter: React.ReactElement
  defaultTitle?: string
  resource?: string
  filterValues?: Record<string, unknown>
  setFilters?: (filters: Record<string, unknown>, displayedFilters?: Record<string, boolean>) => void
  showFilter?: (filterName: string) => void
  displayedFilters?: Record<string, boolean>
  hideFilter?: (filterName: string) => void
  hasSearch?: boolean
  showCreateButton?: boolean
  createButtonLabel?: string
  basePath?: string
  searchBarPlaceholder?: string
}

const filterCloneProps = (props: UtilityTariffCatalogPageChromeProps) => ({
  resource: props.resource,
  showFilter: props.showFilter,
  displayedFilters: props.displayedFilters,
  filterValues: props.filterValues,
  setFilters: props.setFilters,
  hideFilter: props.hideFilter,
})

export const UtilityTariffCatalogPageChrome = (props: UtilityTariffCatalogPageChromeProps) => {
  const {
    heading,
    catalogFilter,
    defaultTitle,
    resource,
    hasSearch = true,
    showCreateButton,
    createButtonLabel,
    basePath,
    searchBarPlaceholder,
    filterValues,
    setFilters,
  } = props

  const translate = useTranslate()
  const sharedFilterProps = filterCloneProps(props)

  const onCreateClick = () => {
    logAmplitudeEvent('control_crud_action', {
      type: 'create',
      resource,
      variant: 'actions',
    })
  }

  return (
    <CatalogPageStack>
      {heading !== false && <UtilityTariffCatalogHeader title={heading} defaultTitle={defaultTitle} />}

      <CatalogToolbarRow>
        <CatalogFilterFields>
          {React.cloneElement(catalogFilter, {
            ...sharedFilterProps,
            context: 'button',
          })}
          {React.cloneElement(catalogFilter, {
            ...sharedFilterProps,
            context: 'form',
          })}
        </CatalogFilterFields>

        <CatalogActionsRow>
          {hasSearch && (
            <UtilityTariffCatalogSearchField
              filterValues={filterValues}
              setFilters={setFilters}
              placeholder={searchBarPlaceholder != null ? translate(searchBarPlaceholder) : undefined}
            />
          )}
          {showCreateButton && (
            <CreateButton
              id={resource ? `list-action-create-button-${resource}` : undefined}
              data-cy="list-action-create-button"
              label={createButtonLabel}
              variant="outlined"
              color="default"
              size="large"
              basePath={basePath}
              onClick={onCreateClick}
            />
          )}
        </CatalogActionsRow>
      </CatalogToolbarRow>
    </CatalogPageStack>
  )
}
